import Button from "../../Button";
import Score from "../../Score/Score";
import constants from "../../../constants";
import ClockSvg from "../../../Svg/ClockSvg";
import { useLocation } from "react-router-dom";
import React, { useContext, useEffect } from "react";
import AlertContext from "../../../context/AlertContext";
import CommentsHooks from "../../../Hooks/CommentsHooks";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import StudentTestBodyPageHooks from "../../../Hooks/StudentTestPage/StudentTestBodyPageHooks";
import CodingHeaderLearnerSideHooks from "../../../Hooks/CodingPage/CodingHeaderLearnerSideHooks";

export default function CodingHeaderLearnerSide() {
  const Alert = useContext(AlertContext);

  const { toggleDrawer } = CommentsHooks();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const StudentTestBodyPageHks = StudentTestBodyPageHooks();
  const CodingHeaderLearnerSideHks = CodingHeaderLearnerSideHooks();

  const { pathname } = useLocation();

 // UseEffect only for CC 
  useEffect(() => {
    if (
      !Alert.isAdmin &&
      !Alert.isLoaded &&
      pathname !== "/mcq" && pathname !== "/sql" &&
      pathname !== "/ainterview" &&
      !Alert.showConfirmNotify &&
      (!Alert.showNotify.show || Alert.showNotify.timer) &&
      Alert.testData.testmode === constants.MODE.TEST_MODE &&
      Alert.status !== constants.QUESTION_STATUS.SUBMITTED &&
      Alert.resultCode !== constants.RESULT_STATUS.NETWORK_ISSUE &&
      Alert.status !== constants.QUESTION_STATUS.TO_BE_EVALUATED
    ) {
      const handleTimeLimit = setInterval(() => {
        Alert.setTimeLimit((seconds) => {
          if (seconds <= 1) {
            // Sql not need here, we are checking along with mcq&desc
            // if (Alert.testData.testtype === constants.libTypeIds.SQL) {
            //   CodingHeaderLearnerSideHks.submitAnswers(
            //     true,
            //     false,
            //     "",
            //     false,
            //     true
            //   );
            // } else {
              CodingHeaderLearnerSideHks.handleSubmitLearnerCodeEvaluation(
                true,
                false,
                true,
                false
              );
            // }

            clearInterval(handleTimeLimit);
            return 0;
          }
          if (seconds !== 0 && seconds % 5 === 0) {
              window?.electronAPI?.sendScreenInfo().then((data) => {
                if (data.monitors && data.monitors > 1) {
                  Alert.setExternalDevices(true);
                  // Sql not need here, we are checking along with mcq&desc
                  // if (Alert.testData.testtype === constants.libTypeIds.SQL) {
                  //   CodingHeaderLearnerSideHks.submitAnswers(false, true);
                  // } else {
                    CodingHeaderLearnerSideHks.handleSubmitLearnerCodeEvaluation(
                      true,
                      true,
                      true,
                      false,
                      false,
                      true
                    );
                  // }
                }
              });
          }

          if (!Alert.testData?.mockuse && seconds !== 0 && seconds % 60 === 0) {
            CodingHeaderLearnerSideHks.saveCurrentAnswer();
          }
            return seconds - 1;
        })
        }, 1000);

      return () => {
        clearInterval(handleTimeLimit);
      };
    }

    if (
      !Alert.isAdmin &&
      !Alert.isLoaded &&
      pathname !== "/mcq" && pathname !== '/sql' &&
      !Alert.showNotify.show &&
      !Alert.showConfirmNotify &&
      Alert.status !== constants.QUESTION_STATUS.SUBMITTED &&
      Alert.testData.testmode === constants.MODE.PRACTICE_MODE &&
      Alert.resultCode !== constants.RESULT_STATUS.NETWORK_ISSUE &&
      Alert.status !== constants.QUESTION_STATUS.TO_BE_EVALUATED 
    ) {
      let handleTimeLimit;
      if (Alert.count === 0) {
         handleTimeLimit = setInterval(() => {
          Alert.setCount(1);
          CodingHeaderLearnerSideHks.saveCurrentAnswer();
        }, 1000);
      } else {
        handleTimeLimit = setInterval(() => {
          CodingHeaderLearnerSideHks.saveCurrentAnswer();
        }, 60000);
      }

      return () => {
          clearInterval(handleTimeLimit);
      };
    }
  }, [
    Alert.count,
    Alert.status,
    Alert.isAdmin,
    Alert.isLoaded,
    Alert.timeLimit,
    Alert.resultCode,
    Alert.showNotify,
    Alert.testDetail,
    Alert.showConfirmNotify,
  ]);

  const onBlur = () => {
    if (!CodingHeaderLearnerSideHks.hasSubmitted) {
      CodingHeaderLearnerSideHks.switchCount.current =
        CodingHeaderLearnerSideHks.switchCount.current + 1;
      CodingHeaderLearnerSideHks.timeoutId.current = setInterval(() => {
        let tempSec = CodingHeaderLearnerSideHks.focusOutSec.current;

        if (
          tempSec === 10 ||
          CodingHeaderLearnerSideHks.switchCount.current === 3
        ) {
          clearInterval(CodingHeaderLearnerSideHks.timeoutId.current);

          if (Alert.testData.ainterview) {
            CodingHeaderLearnerSideHks.submitAnswers(true, false, "interview");
          } else {
            CodingHeaderLearnerSideHks.submitAnswers(true, false);
          }
        } else {
          tempSec++;
          CodingHeaderLearnerSideHks.focusOutSec.current = tempSec;
        }
      }, 1000);
    }
  };

  const onFocus = () => {
    CodingHeaderLearnerSideHks.focusOutSec.current = 0;
    clearInterval(CodingHeaderLearnerSideHks.timeoutId.current);
    window.removeEventListener("blur", onBlur);
  };

  useEffect(() => {
    if (
      !Alert.isAdmin &&
      Alert.testData.testtype !== constants.libTypeIds.CODING_CHALLENGE &&
      parseInt(Alert.mcqAndDesTestAndLpId.libtypeid) !==
      constants.libTypeIds.CODING_CHALLENGE &&
      (Alert.status === constants.PROGRESS_STATUS.UNLOCKED ||
        Alert.status === constants.PROGRESS_STATUS.REATTEMPT ||
        Alert.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION ||
        Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE) &&
      (Alert.testData.testmode === constants.MODE.TEST_MODE ||
        Alert.mcqAndDesTestAndLpId.testmode === constants.MODE.TEST_MODE)
    ) {
      window.addEventListener("blur", onBlur);
      window.addEventListener("focus", onFocus);

      return () => {
        window.removeEventListener("blur", onBlur);
        window.removeEventListener("focus", onFocus);
      };
    }
  }, [Alert.status, onBlur]);

  useEffect(() => {
    if (
      !Alert.isAdmin &&
      pathname !== "/coding" &&
      (Alert.status === constants.PROGRESS_STATUS.UNLOCKED ||
        Alert.status === constants.PROGRESS_STATUS.REATTEMPT ||
        Alert.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION ||
        Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE) &&
      (Alert.testData.testmode === constants.MODE.TEST_MODE ||
        Alert.mcqAndDesTestAndLpId.testmode === constants.MODE.TEST_MODE)
    ) {
      if (!document.fullscreenElement) {
        if (!Alert.comingObj.videoqn) {
          Alert.setIsLoaded(true);
          CodingHeaderLearnerSideHks.submitAnswers(true, false);
        } else {
          if (Alert.testData.ainterview) {
            Alert.setIsLoaded(true);
            CodingHeaderLearnerSideHks.submitAnswers(true, false, "interview");
          } else if (Alert.testData.mockuse && !Alert.testData.ainterview) {
            Alert.setIsLoaded(true);
            Alert.exitVdoSubmit.current = true;
            Alert.setSingleVdoSubmit(true);
            // CodingHeaderLearnerSideHks.submitAnswers(true, false);
          } else {
           Alert.exitVdoSubmit.current = true;
          }
        }
      }
    }
  }, [Alert.status, document.fullscreenElement]);

  useEffect(() => {
    if (
      !Alert.isAdmin &&
      pathname !== "/coding" &&
      (Alert.status === constants.PROGRESS_STATUS.UNLOCKED ||
        Alert.status === constants.PROGRESS_STATUS.REATTEMPT ||
        Alert.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION ||
        Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE) &&
      parseInt(Alert.mcqAndDesTestAndLpId.libtypeid) !==
      constants.libTypeIds.CODING_CHALLENGE &&
      Alert.mcqAndDesTestAndLpId.testmode === constants.MODE.TEST_MODE
    ) {
      if (!CodingHeaderLearnerSideHks.hasSubmitted) {
        Alert.interval.current = setInterval(() => {
          if (Alert.duration.current === 0) {
            if (Alert.comingObj.videoqn !== 1) {
              CodingHeaderLearnerSideHks.submitAnswers(false, true);
            } else {
              Alert.setIsLoaded(true);
              Alert.exitVdoSubmit.current = true;
              Alert.timeVdoSubmit.current = true;
            }

            clearInterval(Alert.interval.current);
          } else {
            Alert.duration.current = Alert.duration.current - 1;

            if (
              Alert.duration.current !== 0 &&
              Alert.duration.current % 5 === 0
            ) {
              window?.electronAPI?.sendScreenInfo().then((data) => {
                if (data.monitors && data.monitors > 1) {
                  Alert.setExternalDevices(true);
                  CodingHeaderLearnerSideHks.submitAnswers(
                    true,
                    false,
                    "",
                    false,
                    true
                  );
                }
              });
            }

            if (
              !Alert.testData?.mockuse &&
              Alert.duration.current !== 0 &&
              Alert.comingObj.videoqn !== 1 &&
              Alert.duration.current % 60 === 0
            ) {
              CodingHeaderLearnerSideHks.saveCurrentAnswer();
            }

            CodingHeaderLearnerSideHks.setTimer(Alert.duration.current);
          }
        }, 1000);

        return () => {
          clearInterval(Alert.interval.current);
        };
      }
    }
// saveanswer for every 60 sec only for SQL Practice Mode
    if (
      !Alert.isAdmin &&
      pathname !== "/coding" && pathname !== "/mcq" &&
      (Alert.status === constants.PROGRESS_STATUS.UNLOCKED ||
        Alert.status === constants.PROGRESS_STATUS.REATTEMPT ||
        Alert.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION ||
        Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE) &&
      parseInt(Alert.mcqAndDesTestAndLpId.libtypeid) === constants.libTypeIds.SQL &&
      Alert.mcqAndDesTestAndLpId.testmode === constants.MODE.PRACTICE_MODE
    ) {

      Alert.interval.current = setInterval(() => {
        if (!Alert.testData?.mockuse && Alert.comingObj.videoqn !== 1) {
              CodingHeaderLearnerSideHks.saveCurrentAnswer();
            }
      }, 60000);

      return () => {
          clearInterval(Alert.interval.current);
      };
    }

    if (
      Alert.isAdmin &&
      (Alert.status === constants.PROGRESS_STATUS.UNLOCKED ||
        Alert.status === constants.PROGRESS_STATUS.REATTEMPT ||
        Alert.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION ||
        Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE) &&
      Alert.mcqAndDesTestAndLpId.testmode !== constants.MODE.TEST_MODE &&
      Alert.comingObj.videoqn !== 1
    ) {
      if (Alert.count === 0) {
        const handleTimeLimit = setInterval(() => {
          Alert.setCount(1);
          CodingHeaderLearnerSideHks.saveCurrentAnswer();
        }, 1000);

        return () => {
          clearInterval(handleTimeLimit);
        };
      } else {
        const handleTimeLimit2 = setInterval(() => {
          CodingHeaderLearnerSideHks.saveCurrentAnswer();
        }, 60000);

        return () => {
          clearInterval(handleTimeLimit2);
        };
      }
    }
  }, [CodingHeaderLearnerSideHks.timer, Alert.count, Alert.comingObj]);
  
  const showSubmitBtn = () => {
    return (
      pathname !== "/ainterview" && Alert?.showBreadCrumbsData?.from !=="learner" &&
      (pathname !== "/mcq" ||
        (Alert.hideSubmitVideoQn &&
          (Alert.testData.testmode !== constants.MODE.PRACTICE_MODE ||
            (!Alert.testData.autoeval &&
              Alert.testData.testtype === constants.libTypeIds.DESCRIPTIVE))))
    );
  };

  return (
    <div className="codingHeaderLearnerSideMainContainer">
      {CodingHeaderLearnerSideHks.handleShowSubmitDiv() ? (
        <div className="codingHeaderLearnerSideSubmitDiv">
          {pathname === "/ainterview" ? (
            <div className="codingHeaderLearnerSideInterviewTimerDiv">
              <ClockSvg component="interview" />
              {useCommonFunctionHks.formatTime(Alert.comingObj.duration)}
            </div>
          ) : (
            !Alert.testData.hasOwnProperty("lccid") &&
            Alert.testData.testmode === constants.MODE.TEST_MODE && (
              <div className="codingHeaderLearnerSideTimerDiv">
                <ClockSvg />
                {pathname !== "/mcq" && pathname !== "/sql" ? (
                  <div className="codingHeaderLearnerSideTimerInnerDiv">
                    <span>
                      {Math.floor((Alert.timeLimit % 3600) / 60).toString()
                        .length === 1
                        ? "0" + Math.floor((Alert.timeLimit % 3600) / 60)
                        : Math.floor((Alert.timeLimit % 3600) / 60)}
                    </span>
                    {" : "}
                    <span>
                      {Math.floor((Alert.timeLimit % 3600) % 60).toString()
                        .length === 1
                        ? "0" + Math.floor((Alert.timeLimit % 3600) % 60)
                        : Math.floor((Alert.timeLimit % 3600) % 60)}
                    </span>
                  </div>
                ) : (
                  <div className="codingHeaderLearnerSideTimerInnerDiv">
                    {Alert.comingObj.videoqn === 1 && <span>Total time: </span>}
                    <span>
                      {Math.floor(
                        CodingHeaderLearnerSideHks.timer / 3600
                      ).toString().length === 1
                        ? "0" +
                        Math.floor(CodingHeaderLearnerSideHks.timer / 3600)
                        : Math.floor(CodingHeaderLearnerSideHks.timer / 3600)}
                    </span>
                    {" : "}
                    <span>
                      {Math.floor(
                        (CodingHeaderLearnerSideHks.timer % 3600) / 60
                      ).toString().length === 1
                        ? "0" +
                        Math.floor(
                          (CodingHeaderLearnerSideHks.timer % 3600) / 60
                        )
                        : Math.floor(
                          (CodingHeaderLearnerSideHks.timer % 3600) / 60
                        )}
                    </span>
                    {" : "}
                    <span>
                      {Math.floor(
                        (CodingHeaderLearnerSideHks.timer % 3600) % 60
                      ).toString().length === 1
                        ? "0" +
                        Math.floor(
                          (CodingHeaderLearnerSideHks.timer % 3600) % 60
                        )
                        : Math.floor(
                          (CodingHeaderLearnerSideHks.timer % 3600) % 60
                        )}
                    </span>
                  </div>
                )}
              </div>
            )
          )}
          {showSubmitBtn() && (
            <div className="header-learner-submit-btn-div">
              <Button
                size="sm"
                // disable={Alert.testData.testtype===constants.libTypeIds.SQL && Alert.testDetail.currentIndex !==
                //           Alert.testDetail.data.sections[0]?.questions.length - 1}
                onClick={() => {
                  pathname !== "/mcq" && pathname !== "/sql"
                    ? CodingHeaderLearnerSideHks.handleSubmitLearnerCodeEvaluation(
                      false,
                      false,
                      false,
                      false
                    )
                    : Alert.comingObj.videoqn
                      ? (() => {
                        StudentTestBodyPageHks.stopListening();
                        CodingHeaderLearnerSideHks.submitAnswers();
                      })()
                      : pathname === "/sql"
                        ? CodingHeaderLearnerSideHks.handleSubmit()
                        : CodingHeaderLearnerSideHks.submitAnswers();
                }}
                hierarchy={{
                  type: "primary",
                  buttonText: "Submit",
                }}
              />
            </div>
          )}
        </div>
      ) : (
        CodingHeaderLearnerSideHks.handleShowCommentsButton() && (
          <div className="codingHeaderLearnerSideSubmissionDiv">
            {CodingHeaderLearnerSideHks.handleShowScore() && <Score />}
            <Button
              size={"sm"}
              onClick={toggleDrawer("right", true)}
              hierarchy={{
                type: "secondaryGrey",
                buttonText: "View Comments",
              }}
            />
          </div>
        )
      )}
    </div>
  );
}
